<style lang="stylus">
    .batchReplaceImgModal-mask
      modal-mask()
      .batchReplaceImgModal-container
        padding-bottom: 24px
        font-size 12px
        line-height 16px
        width 480px
        .text-red
          color #FF5353
        .desc
          color #222222
        .uploadErr-tips
          margin-top 4px
        .uploadTips-box
          margin 16px 0
          height 84px
          border 2px dashed rgba(0, 0, 0, 0.1)
          background var(--theme-color-4)
          border-radius 6px
          display flex
          flex-direction column
          justify-content center
          align-items center
          padding 16px
          color var(--text-color-tertiary)
          &:hover,&.active
            border-color var(--themeColor)
            background var(--theme-color-6)
            color var(--themeColor)
            .item-icon
              color: var(--svg-color-active)
          .item-icon
            width 32px;
            height 32px;
            color: var(--svg-color-gray-42)
          .text
            margin-top 4px
        .empty-box,.content-box
          height 172px
          border 1px solid rgba(0, 0, 0, 0.06)
          border-radius 6px
        .empty-box
          display flex
          flex-direction column
          justify-content center
          align-items center
        .content-box
          display flex
          flex-direction column
          overflow auto
          .item
            height 32px
            padding 8px 16px
            display flex
            &:hover
              background rgba(0, 0, 0, 0.04)
              .operation
                .close-show
                  display block
            .name
              width 70%
              overflow hidden
              text-overflow ellipsis
              white-space nowrap
            .operation
              width 30%
              display flex
              justify-content flex-end
              align-items center
              .close-icon
                width 16px
                height 16px
                display none
                cursor pointer
              .tick-icon
                width 16px
                height 16px
                stroke rgba(0, 0, 0, 0.2)
                cursor pointer
                &.active
                  fill var(--themeColor)
                  stroke var(--themeColor)
</style>

<template>
    <div class="batchReplaceImgModal-mask">
        <Dialog :title="$t('title')" @ok="submitChange" @close="cancelChange" :showFooter="true" :disablConfirm="disablConfirm">
            <div class="batchReplaceImgModal-container">
                <p class="dec">{{ $t("desc") }}</p>
                <p class="uploadErr-tips text-red" v-if="showUploadErr">{{ $t("uploadErr") }}</p>
                <div
                    class="uploadTips-box"
                    :class="{ active: isDragHover }"
                    @click="uploadImg"
                    @dragenter="dragEnter($event)"
                    @dragleave="dragLeave($event)"
                    @drop.prevent="drop($event)"
                    @dragover.prevent
                >
                    <iconSymbol name="uploadImg" class="item-icon" />
                    <div class="text">{{ $t("uploadTips") }}</div>
                </div>
                <div class="empty-box" v-if="imgList.length == 0">
                    <img src="@/app/assets/img/empty-box.svg" alt="" />
                </div>
                <div class="content-box" v-else>
                    <div class="item" :class="{ 'text-red': !item.uploadsuccess }" v-for="(item, index) in imgList" :key="item.name">
                        <div class="name" :title="item.name">
                            {{ item.name }}
                        </div>
                        <div class="operation">
                            <iconSymbol
                                :class="{ 'close-show': !item.uploadsuccess }"
                                class="close-icon"
                                name="close"
                                @click.native="deleteImg(index)"
                            />
                            <iconSymbol
                                v-if="item.uploadsuccess"
                                class="tick-icon"
                                :class="{ active: item.select }"
                                name="cricle-tick"
                                @click.native="toggleImg(item)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <input style="display: none" accept=".bmp, .png, .jpg, .jpeg, .gif, .ico" ref="replaceImg" type="file" @change="getImg($event)" multiple />
    </div>
</template>

<script lang="ts">
    type imgListType = {
        id: number;
        select: boolean;
        uploadsuccess: boolean;
        name: string;
        file: File;
    };
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "@/app/components/Modals/Dialog.vue";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class BatchReplaceImgModal extends Vue {
        imgList: Array<imgListType> = [];
        isDragHover: boolean = false;
        showUploadErr: boolean = false;
        disablConfirm: boolean = true;
        @Watch("imgList", { deep: true })
        watchImgList(newVal: Array<imgListType>) {
            let hasUploadErrImg = newVal.some((item) => {
                return !item.uploadsuccess;
            });
            let hasUploadSuccess = newVal.some((item) => {
                return item.uploadsuccess && item.select;
            });
            this.showUploadErr = hasUploadErrImg;
            this.disablConfirm = !hasUploadSuccess;
        }
        submitChange() {
            window["_view"].batchReplaceImgImOrgshape(this.imgList);
            this.resetStatus();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.sensors.track("editOrganizationChart", {
                Catalogues: "shortcutToolbar",
                content: "batchReplaceImgImOrgshape",
            });
        }
        cancelChange() {
            this.resetStatus();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        resetStatus() {
            this.imgList = [];
            this.showUploadErr = false;
            this.disablConfirm = true;
        }
        uploadImg() {
            (this.$refs.replaceImg as HTMLInputElement).click();
        }
        getImg(e) {
            let files = e.target.files;
            this.uploadOperation(files);
        }
        uploadOperation(files: FileList) {
            if (!files || files.length == 0) return;
            let map = new Map();
            for (let i = 0; i < files.length; i++) {
                if (files[i].size !== 0) {
                    map.set(files[i].name.replace(/.([a-z|A-Z]*?)$/g, ""), files[i]);
                }
            }
            let len = this.imgList.length;
            let index = len ? this.imgList[len - 1].id : 0;
            let [successList, failList] = window["_view"].getOrgshapeImgCompareResult(map, index);
            if (successList.length != 0) {
                this.disablConfirm = true;
            }
            if (failList.length != 0) {
                this.showUploadErr = true;
            }
            let tempList = [...successList, ...failList];
            for (let item of tempList) {
                // 是否有名字重复的
                for (let index in this.imgList) {
                    if (this.imgList[index].name == item.name) {
                        // 删除
                        this.imgList.splice(Number(index), 1);
                        break;
                    }
                }
                this.imgList.push(item);
            }
        }
        deleteImg(index: number) {
            this.imgList.splice(index, 1);
        }
        toggleImg(item: imgListType) {
            item.select = !item.select;
        }
        dragEnter(event) {
            if (event.target.className == "uploadTips-box") {
                this.isDragHover = true;
            }
        }
        dragLeave(event) {
            if (event.target.className == "uploadTips-box") {
                this.isDragHover = false;
            }
        }
        drop(event) {
            this.getImg(event);
            this.uploadOperation(event.dataTransfer.files);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "批量替换",
    "desc": "为确保操作成功，请确保照片名称与员工ID或姓名做到一一匹配。",
    "uploadErr": "红色的照片名称与员工姓名或员工ID匹配失败，因此无法上传。请重命名这些文件，然后重试。",
    "uploadTips": "选择要上传的照片，或将他们拖到此处。"
  },
  "en": {
    "title": "Batch Replace",
    "desc": "To make sure that the operation is successful, please ensure that the photo name matches the employee ID exactly.",
    "uploadErr": "Upload failed. The photo name in red does not match the employee name or employee ID. Please rename these files and try again.",
    "uploadTips": "Select the images you wish to upload, or drag them here."
  },
  "fr": {
    "title": "Remplacement par lot",
    "desc": "Pour garantir une opération réussie, assurez-vous que le nom de la photo correspond exactement à l'identifiant de l'employé.",
    "uploadErr": "Échec du téléchargement. Le nom de la photo en rouge ne correspond pas au nom ou à l'identifiant de l'employé. Veuillez renommer ces fichiers et réessayer.",
    "uploadTips": "Sélectionnez les images que vous souhaitez télécharger ou faites-les glisser ici."
  },
  "de": {
    "title": "Stapel ersetzen",
    "desc": "Um sicherzustellen, dass der Vorgang gelingt, stellen Sie bitte sicher, dass der Name des Fotos genau mit der Mitarbeiterkennung übereinstimmt.",
    "uploadErr": "Upload fehlgeschlagen. Der Name des Fotos in Rot stimmt nicht mit dem Namen des Mitarbeiters oder der Mitarbeiterkennung überein. Benennen Sie diese Dateien um und versuchen Sie es erneut.",
    "uploadTips": "Wählen Sie die Bilder aus, die Sie hochladen möchten oder ziehen Sie sie hierher."
  },
  "jp": {
    "title": "一括置き換え",
    "desc": "操作が正常に行われたことを確認するため、写真名が従業員 ID と正確に一致していることを確認してください。",
    "uploadErr": "アップロードできませんでした。赤で表示されている写真名が従業員の名前または ID と一致しません。ファイルの名前を変更して、もう一度やり直してください。",
    "uploadTips": "アップロードする画像を選択するか、ここにドラッグします。"
  },
  "es": {
    "title": "Sustitución en lote",
    "desc": "Para asegurarse de que la operación se realiza correctamente, compruebe que el nombre de la fotografía coincida exactamente con el ID del empleado.",
    "uploadErr": "La carga ha fallado. El nombre de la foto en rojo no coincide con el nombre o el ID del empleado. Cambie el nombre de estos archivos e inténtelo de nuevo.",
    "uploadTips": "Seleccione las imágenes que desee cargar o arrástrelas aquí."
  },
  "pt": {
    "title": "Substituição em lote",
    "desc": "Para garantir que a operação seja bem-sucedida, certifique-se de que o nome da foto corresponda exatamente ao ID do funcionário.",
    "uploadErr": "Falha no carregamento. O nome da foto em vermelho não corresponde ao nome do funcionário ou ID de funcionário. Renomeie esses arquivos e tente novamente.",
    "uploadTips": "Selecione as imagens que deseja carregar ou arraste-as aqui."
  },
  "it": {
    "title": "Sostituzione in batch",
    "desc": "Perché l'operazione vada a buon fine, assicurati che il nome della foto coincida esattamente con l'ID del dipendente.",
    "uploadErr": "Caricamento non riuscito. Il nome della foto in rosso non corrisponde al nome o all'ID del dipendente. Rinomina i file e riprova.",
    "uploadTips": "Seleziona o trascina qui le immagini da caricare."
  },
  "tw": {
    "title": "批次取代",
    "desc": "為確保操作成功，請確認相片名稱與員工 ID 完全相符。",
    "uploadErr": "上傳失敗。標示為紅色的相片名稱與員工姓名或員工 ID 不相符。請為這些檔案重新命名並再試一次。",
    "uploadTips": "選取要上傳的影像，或將影像拖曳到這裡。"
  },
  "kr": {
    "title": "배치 교체",
    "desc": "작업이 성공적으로 이루어지도록 사진 이름이 직원 ID에 정확하게 일치하는지 확인하십시오.",
    "uploadErr": "업로드 실패했습니다. 빨간색으로 표시된 사진 이름이 직원 이름 또는 직원 ID와 일치하지 않습니다. 이 파일의 이름을 바꾸고 다시 시도하십시오.",
    "uploadTips": "업로드하고 싶은 이미지를 선택하거나 여기로 드래그하십시오."
  }
}
</i18n>
